<template>
  <vs-popup 
    title="Add link" 
    :active.sync="popupActive" 
    v-if="popupActive"
  >
    <div class="vx-col w-full mb-base">
      URL:
      <vs-input 
        class="vx-col w-1/1 lg:w-1/1" 
        style="width:100%;"
        label-placeholder="URL:"
        v-model="linkUrl" 
      />
      Text(will default to the URL):
      <vs-input 
        class="vx-col w-1/1 lg:w-1/1" 
        style="width:100%;"
        label-placeholder="Text:"
        v-model="linkText" 
      />
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vs-button @click="onAddLink">Add</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'LinkPopup',
  
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      linkUrl: '',
      linkText: ''
    }
  },

  computed: {
    popupActive: {
      get() {
        return this.isActive
      },
      set(value) {
        this.$emit('update:isActive', value)
      }
    }
  },

  methods: {
    onAddLink() {
      const text = this.linkText || this.linkUrl
      this.$emit('add-link', {
        url: this.linkUrl,
        text: text
      })
      this.resetForm()
      this.popupActive = false // Close popup after adding link
    },

    resetForm() {
      this.linkUrl = ''
      this.linkText = ''
    }
  },

  watch: {
    isActive(newVal) {
      if (!newVal) {
        this.resetForm()
      }
    }
  }
}
</script> 